module.exports = __webpack_public_path__ + "static/img/img-educator-feature-3-m@3x.a4c5f6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/educator/img-educator-feature-3-m@3x.png
// module id = +pHn
// module chunks = 18